// English + Hebrew text for the coach settings form, share card and question editor.
export const dietitianStrings = {
  english: {
    loading: 'Loading…',
    loadError: 'Could not load the settings.',
    retry: 'Try again',

    'share.title': 'Your client link',
    'share.codeLabel': 'Your code',
    'share.linkLabel': 'Client link',
    'share.copyLink': 'Copy link',
    'share.copyCode': 'Copy code',
    'share.copied': 'Copied',
    'share.whatsapp': 'Send on WhatsApp',
    'share.qrLabel': 'QR code of your client link',
    'share.qrHint': 'Clients can scan this from your screen or a printout.',
    'share.noCode': 'Save a code below to get your link.',
    'share.unsaved': 'You have unsaved changes. The link above is the saved one.',

    'form.inherit': "Anything you leave empty uses your company's settings.",
    'form.codeSection': 'Code',
    'form.code': 'Invite code',
    'form.codeHint': '3–20 capital letters, numbers or dashes. Clients can type it at signup.',
    'form.codeSuggested': 'Suggested from your name. Save to claim it.',
    'form.code.required': 'Enter a code.',
    'form.code.tooShort': 'Use at least 3 characters.',
    'form.code.invalid': 'Use only A–Z, 0–9 and dashes.',
    'form.code.taken': 'That code is taken. Try another one.',
    'form.saveError': 'Could not save: {msg}',
    'form.profileSection': 'What clients see',
    'form.displayName': 'Display name',
    'form.displayNamePlaceholder': 'e.g. Dana Cohen',
    'form.title': 'Title',
    'form.titlePlaceholder': 'e.g. Clinical dietitian',
    'form.photo': 'Photo',
    'form.photoUrl': 'Photo link (https)',
    'form.photo.https': 'Use an https:// link.',
    'form.welcome': 'Welcome message',
    'form.welcomePlaceholder': 'A short note clients read before they sign up.',
    'form.planSection': 'Plan',
    'form.planHint': 'The price and trial your clients get.',
    'form.planCompany': 'Company default',
    'form.planCompanyHint': "Use the company's pricing",
    'form.noPlans': 'No plans yet. Ask BetterChoice to add one.',
    'form.questionsSection': 'Extra onboarding questions',
    'form.questionsHint': 'Asked after the standard onboarding, only to your clients.',
    'form.save': 'Save changes',
    'form.saving': 'Saving…',
    'form.saved': 'Saved',
    'form.nothingToSave': 'No changes to save.',
    'form.fixErrors': 'Fix the highlighted fields first.',
    'form.reset': 'Discard changes',

    'preview.title': 'Preview',
    'preview.hint': 'What clients see when they open your link.',
    'preview.join': 'Start my plan',

    'steps.add': 'Add question',
    'steps.empty': 'No extra questions.',
    'steps.question': 'Question',
    'steps.questionPlaceholder': 'e.g. What is your main goal?',
    'steps.description': 'Description (optional)',
    'steps.type': 'Answer type',
    'steps.typeText': 'Text',
    'steps.typeSelect': 'Single choice',
    'steps.typeMultiselect': 'Multiple choice',
    'steps.options': 'Answer choices',
    'steps.optionPlaceholder': 'Type a choice and press Enter',
    'steps.addOption': 'Add choice',
    'steps.removeOption': 'Remove choice',
    'steps.moveUp': 'Move up',
    'steps.moveDown': 'Move down',
    'steps.remove': 'Remove question',
    'steps.number': 'Question {n}',
    'steps.err.question': 'Write the question.',
    'steps.err.options': 'Add at least one choice.',
  },
  hebrew: {
    loading: 'טוען…',
    loadError: 'לא הצלחנו לטעון את ההגדרות.',
    retry: 'נסו שוב',

    'share.title': 'הקישור שלך ללקוחות',
    'share.codeLabel': 'הקוד שלך',
    'share.linkLabel': 'קישור ללקוחות',
    'share.copyLink': 'העתקת קישור',
    'share.copyCode': 'העתקת קוד',
    'share.copied': 'הועתק',
    'share.whatsapp': 'שליחה בוואטסאפ',
    'share.qrLabel': 'קוד QR של הקישור שלך',
    'share.qrHint': 'לקוחות יכולים לסרוק מהמסך או מדף מודפס.',
    'share.noCode': 'שמרו קוד למטה כדי לקבל קישור.',
    'share.unsaved': 'יש שינויים שלא נשמרו. הקישור למעלה הוא השמור.',

    'form.inherit': 'כל שדה שנשאר ריק יקבל את הגדרות החברה.',
    'form.codeSection': 'קוד',
    'form.code': 'קוד הזמנה',
    'form.codeHint': '3–20 אותיות באנגלית, ספרות או מקפים. לקוחות יכולים להקליד אותו בהרשמה.',
    'form.codeSuggested': 'הצעה לפי השם שלך. שמרו כדי לשריין אותו.',
    'form.code.required': 'הזינו קוד.',
    'form.code.tooShort': 'לפחות 3 תווים.',
    'form.code.invalid': 'רק A–Z, ‏0–9 ומקפים.',
    'form.code.taken': 'הקוד הזה תפוס. נסו קוד אחר.',
    'form.saveError': 'השמירה נכשלה: {msg}',
    'form.profileSection': 'מה הלקוחות רואים',
    'form.displayName': 'שם לתצוגה',
    'form.displayNamePlaceholder': 'למשל: דנה כהן',
    'form.title': 'תואר',
    'form.titlePlaceholder': 'למשל: דיאטנית קלינית',
    'form.photo': 'תמונה',
    'form.photoUrl': 'קישור לתמונה (https)',
    'form.photo.https': 'השתמשו בקישור שמתחיל ב-https://',
    'form.welcome': 'הודעת פתיחה',
    'form.welcomePlaceholder': 'כמה מילים שהלקוחות יקראו לפני ההרשמה.',
    'form.planSection': 'מסלול',
    'form.planHint': 'המחיר ותקופת הניסיון שהלקוחות שלך מקבלים.',
    'form.planCompany': 'ברירת המחדל של החברה',
    'form.planCompanyHint': 'לפי התמחור של החברה',
    'form.noPlans': 'אין מסלולים עדיין. בקשו מ-BetterChoice להוסיף.',
    'form.questionsSection': 'שאלות הצטרפות נוספות',
    'form.questionsHint': 'נשאלות אחרי ההצטרפות הרגילה, רק ללקוחות שלך.',
    'form.save': 'שמירת שינויים',
    'form.saving': 'שומר…',
    'form.saved': 'נשמר',
    'form.nothingToSave': 'אין שינויים לשמירה.',
    'form.fixErrors': 'תקנו קודם את השדות המסומנים.',
    'form.reset': 'ביטול שינויים',

    'preview.title': 'תצוגה מקדימה',
    'preview.hint': 'מה הלקוחות רואים כשהם פותחים את הקישור שלך.',
    'preview.join': 'מתחילים את התוכנית',

    'steps.add': 'הוספת שאלה',
    'steps.empty': 'אין שאלות נוספות.',
    'steps.question': 'שאלה',
    'steps.questionPlaceholder': 'למשל: מה המטרה העיקרית שלך?',
    'steps.description': 'תיאור (לא חובה)',
    'steps.type': 'סוג תשובה',
    'steps.typeText': 'טקסט',
    'steps.typeSelect': 'בחירה יחידה',
    'steps.typeMultiselect': 'בחירה מרובה',
    'steps.options': 'אפשרויות תשובה',
    'steps.optionPlaceholder': 'הקלידו אפשרות ולחצו Enter',
    'steps.addOption': 'הוספת אפשרות',
    'steps.removeOption': 'הסרת אפשרות',
    'steps.moveUp': 'הזזה למעלה',
    'steps.moveDown': 'הזזה למטה',
    'steps.remove': 'הסרת שאלה',
    'steps.number': 'שאלה {n}',
    'steps.err.question': 'כתבו את השאלה.',
    'steps.err.options': 'הוסיפו לפחות אפשרות אחת.',
  },
};
